var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-select"},[_c('ul',_vm._l((_vm.dataList),function(item){return _c('li',{staticClass:"border-1px",on:{"click":function($event){return _vm.toShare(item)}}},[_c('span',[_vm._v(_vm._s(item.dishName))]),_vm._v(" "),_c('span',{staticClass:"iconfont icon-right right-icon"})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2ae87a4b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/share/share-select.vue
// module id = null
// module chunks = 